<template>
  <div class="inventory-info" v-if="inventoryInfo">
    <div class="inventory-title">
      记录编号: {{ inventoryInfo.guid }}
      <span class="inventory-status canceling" v-if="inventoryInfo.optCancel == 1">
        取消中
      </span>
      <span class="inventory-status canceled" v-if="inventoryInfo.optCancel == 2">
        已取消
      </span>
    </div>
    <div v-if="inventoryTypeLabel">
      记录类型:
      <span :class="inventoryTypeClassName">{{ inventoryTypeLabel }}</span>
    </div>
    <div v-if="inventoryInfo.outboundChannelInfo">
      出库渠道:
      <span>
        {{ inventoryInfo.outboundChannelInfo.name || "-" }}
      </span>
    </div>
    <div v-if="inventoryInfo.orderGuid && inventoryInfo.orderGuid > 0">
      销售单号:
      <span>
        {{ inventoryInfo.orderGuid }}
      </span>
    </div>
    <div v-if="inventoryInfo.arrangedGuid && inventoryInfo.arrangedGuid > 0">
      计划单号:
      <span>
        {{ inventoryInfo.arrangedGuid }}
      </span>
    </div>
    <div v-if="inventoryInfo.purchaseGuid && inventoryInfo.purchaseGuid > 0">
      采购单号:
      <span>
        {{ inventoryInfo.purchaseGuid }}
      </span>
    </div>
    <div v-if="inventoryInfo.memberInfo">
      消费客户:
      <span>
        {{
          [inventoryInfo.memberInfo.phone, inventoryInfo.memberInfo.nickname]
            .filter((item) => !!item)
            .join("-")
        }}
      </span>
    </div>
    <div v-if="inventoryInfo.consumeName">
      消费者姓名:
      {{ inventoryInfo.consumeName }}
    </div>
    <div v-if="inventoryInfo.consumePhone">
      消费者电话:
      {{ inventoryInfo.consumePhone }}
    </div>
    <div v-if="inventoryInfo.createTime > 0">
      创建时间:
      <span>
        {{ new Date(inventoryInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div v-if="inventoryInfo.inboundCount">
      入库数量:
      <span>
        {{ inventoryInfo.inboundCount }}
      </span>
      <span> 份商品 </span>
    </div>
    <div v-if="inventoryInfo.outboundCount">
      出库数量:
      <span>
        {{ inventoryInfo.outboundCount }}
      </span>
      <span> 份商品 </span>
    </div>
    <div v-if="inventoryInfo.handledBy">
      经手人员:
      <span>
        {{ inventoryInfo.handledBy }}
      </span>
    </div>
    <div v-if="inventoryInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="inventory-remark">{{ inventoryInfo.optRemark }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.inventory-info {
  line-height: 26px;
  font-size: 14px;
}

.inventory-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}

.inventory-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.inventory-item-list {
  background: #fafafa;
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px;
}

.inventory-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;

  &.stock_inbound {
    background-color: #b24eff;
    border: 1px solid #b24eff;
    color: #ffffff;
  }

  &.stock_outbound {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.stock_split {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.stock_sheet {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.replenish_inbound {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.replenish_outbound {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }

  &.order_sale {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.order_return {
    background-color: #f56c6c;
    border: 1px solid #f56c6c;
    color: #ffffff;
  }

  &.canceling {
    background-color: #f56c6c;
    border: 1px solid #f56c6c;
    color: #ffffff;
  }

  &.canceled {
    background-color: #919191;
    border: 1px solid #919191;
    color: #ffffff;
  }
}
</style>

<script>
import goodsSkuInfo from "./goodsSkuInfo.vue";

export default {
  components: {
    goodsSkuInfo,
  },
  props: {
    inventoryInfo: {
      type: Object,
    },
  },
  methods: {
    getGoodsCount(skuGuid, inventoryType) {
      let count = 0;
      if (this.inventoryInfo) {
        if (this.inventoryInfo.inventoryType == inventoryType) {
          (this.inventoryInfo.itemList || []).forEach((goods) => {
            if (goods.skuGuid == skuGuid) {
              count += goods.goodsCount;
            }
          });
        }
      }
      return count;
    },
  },
  computed: {
    orderGoodsList() {
      let goodsList = [];
      let skuGuids = [];
      if (this.inventoryInfo) {
        (this.inventoryInfo.itemList || []).forEach((goods) => {
          if (skuGuids.indexOf(goods.skuGuid) < 0) {
            goodsList.push(goods);
            skuGuids.push(goods.skuGuid);
          }
        });
      }
      return goodsList;
    },
    inventoryTypeClassName() {
      if (!this.inventoryInfo) {
        return "";
      }
      return "inventory-status " + this.inventoryInfo.inventoryType;
    },
    inventoryTypeLabel() {
      if (!this.inventoryInfo) {
        return "";
      }
      if (this.inventoryInfo.inventoryType === "stock_inbound") {
        return "库存-入库";
      } else if (this.inventoryInfo.inventoryType === "stock_outbound") {
        return "库存-出库";
      } else if (this.inventoryInfo.inventoryType === "stock_split") {
        return "库存-拆零";
      } else if (this.inventoryInfo.inventoryType === "stock_sheet") {
        return "库存-盘点";
      } else if (this.inventoryInfo.inventoryType === "replenish_outbound") {
        return "调货-出库";
      } else if (this.inventoryInfo.inventoryType === "replenish_inbound") {
        return "补货-入库";
      } else if (this.inventoryInfo.inventoryType === "purchase_inbound") {
        return "采购-入库";
      } else if (this.inventoryInfo.inventoryType === "order_sale") {
        return "订单-售出";
      } else if (this.inventoryInfo.inventoryType === "order_return") {
        return "订单-退货";
      }
      return this.inventoryInfo.inventoryType;
    },
  },
};
</script>
